export const state = {
  filters: {
    conversionType: {
      value: null,
      modifiers: {
        matchType: 'contains'
      },
      title: 'Conversion Type',
      type: 'input'
    },
    type: {
      title: 'Type',
      type: 'select',
      multiple: false,
      optionLabelKey: 'slug',
      trackByKey: 'slug',
      value: null
    }
  },
  orderBy: [
    {
      column: 'created_at',
      order: 'ASC'
    }
  ]
}
